export const PHONE_REGEX =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
export const LOGIN = "login";
export const REGISTER = "register";
export const COOKIE_AUTH_NAME = "authorization";
export const COOKIE_REFRESH_TOKEN_NAME = "x-refresh-token";
export const COOKIE_PASSWORD_TOKEN_NAME = "token";
export const passwordLength = 12;
export const usernameLength = 5;
